import io from "socket.io-client";
import moment from "moment";
import { dateUTCComplete } from "@/helpers/date";

const socket = io(process.env.VUE_APP_API);
const tenant = window.location.host.split(".")[0];

export async function socketSender(channel, data) {
  let socketData = {
    tenant,
    msg: data,
    date: moment(dateUTCComplete(new Date())).format("YYYY-M-D"),
    dateTime: moment(dateUTCComplete(new Date())).format("YYYY-M-D H:mm:ss")
  };
  await socket.emit(channel, socketData);
}
